import { render, staticRenderFns } from "./PosView.vue?vue&type=template&id=1b6ca30b&scoped=true&"
import script from "./PosView.vue?vue&type=script&lang=js&"
export * from "./PosView.vue?vue&type=script&lang=js&"
import style0 from "./PosView.vue?vue&type=style&index=0&id=1b6ca30b&scoped=true&lang=css&"
import style1 from "./PosView.vue?vue&type=style&index=1&id=1b6ca30b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b6ca30b",
  null
  
)

export default component.exports